import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../Home/HomePage.module.css"; // adjust to your module
import { apiFetch } from "../../api";

const API = "https://simplix.co.za/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((s || "").trim());

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!isEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const r = await fetch(`${API}/auth/forgot-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      if (!r.ok) {
        const t = await r.text().catch(() => "");
        throw new Error(t || "Something went wrong. Please try again.");
      }

      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (sent) {
    return (
      <div className={styles.authShell}>
        <div className={styles.authCard}>
          <div className={styles.authHeader}>
            <p className={styles.sectionEyebrow}>Check your email</p>
            <h2>Reset link sent</h2>
          </div>
          <p>
            If <strong>{email.trim()}</strong> is registered, you'll receive an
            email with a link to reset your password. The link expires in 15 minutes.
          </p>
          <div className={styles.authHelp}>
            <button className={styles.primaryBtn} onClick={() => navigate("/login")}>
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.authShell}>
      <div className={styles.authCard}>
        <div className={styles.authHeader}>
          <p className={styles.sectionEyebrow}>Account access</p>
          <h2>Forgot password</h2>
          <p>Enter your email and we'll send you a reset link.</p>
        </div>

        <form className={styles.authForm} onSubmit={handleSubmit}>
          <input
            className={styles.authInput}
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />

          {error && <div className={styles.authError}>{error}</div>}

          <div className={styles.authHelp}>
            <button
              className={styles.primaryBtn}
              type="submit"
              disabled={loading}
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </div>

          <div className={styles.authHelp}>
            <button
              type="button"
              className={styles.navBtnGhostDark}
              onClick={() => navigate("/#/login")}
            >
              ← Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}